import * as angular from 'angular';

class BatchVisitController {
  private loaded: boolean;
  private shouldLoad: boolean | undefined;
  private visits: any;
  private processing: boolean | undefined;
  private lazyLoad: boolean | undefined;
  constructor(
    private toastr: any,
    private Notifications: any,
    private Orders: any,
    private Pharmacy: any,
    private Utils: any,
    private MedicationService: any
  ) {
    'ngInject';
    Object.assign(this, {
      toastr,
      pagination: { limit: 20, offset: 0 },
      visits: [],
    });
    this.loaded = false;
  }

  $onInit() {
    if (!this.lazyLoad) {
      this.search();
    }
  }

  $onChanges() {
    if (!this.loaded && this.shouldLoad) {
      this.search();
    }
  }

  getDosespotDrugName(dm: any) {
    if (!dm) {
      return '';
    }

    const drugName = dm.matched_drug_name.split(' (')[0];

    return `${drugName} ${dm.strength_description} ${dm.dose_form_description}`;
  }

  /**
   * Determines if all visits have been checked in the UI
   * @returns {boolean} true/false
   */
  areAllVisitsSelected() {
    return this.visits.every((v: { selected: any; }) => v.selected);
  }

  areAnyVisitsSelected() {
    return this.visits.some((v: { selected: any; }) => v.selected);
  }

  /**
   * Toggles selection of all visits
   * @returns {void}
   */
  toggleSelectAll() {
    const allSelected = this.areAllVisitsSelected();
    this.visits = this.visits.map((v: { selected: boolean; }) => {
      v.selected = !allSelected;
      return v;
    });
  }

  /**
   * Toggles whether visit is selected in UI
   * @param event
   * @param {object} visit - visit to toggle selection
   * @returns {object} visit
   */
  toggleVisitSelected(event: Event, visit: any) {
    event.preventDefault();
    event.stopPropagation();
    visit.selected = !visit.selected;
    return visit;
  }

  /**
   * Processes all double green visits in queue
   * 1. Check to see if visit is still able to be batch-processed, if it fails
        remove it from the list
   * 2. Approve photos
   * 3. Post medications to orderline
   * 4. Create Dosespot Prescriptions
   * 5. Send Dosespot Prescription
   * 6. Complete Visit
   */
  processOneVisit(visit: any) {
    visit.processing = true;
    visit.error = false;
    visit.success = false;

    return this.Orders.isPrescreened(visit.id)
    // @ts-ignore
    .then(({ data: isBatchable }) => {
      if (isBatchable) {
        return this.Orders
          .setPhotos(visit.id, { approved: true, diagnosis: `Prescreen - ${visit.service.code}` })
          .then(() => this.Orders.postMedications(visit.id, [visit.default_medication]))
          .then(() => this.Orders.getOne(visit.id))
        // @ts-ignore
          .then(({ data }) => this.Orders.performCompletionSeries(data))
          .then(() => {
            visit.success = true;
            setTimeout(
              () => {
                const index = this.visits.indexOf(visit);
                this.visits.splice(index, 1);
              },
              1000,
            );
          })
          .catch((err: any) => {
            visit.error = this.Utils.getApiErrorMessage(err, 'Something went horribly wrong.');
            this.Utils.createErrorToast(err, 'Something went horribly wrong.');
          })
          .finally(() => {
            visit.processing = false;
          });
      }

      visit.processing = false;
      const index = this.visits.indexOf(visit);
      this.visits.splice(index, 1);
      // @ts-ignore
      return new Promise.resolve();
    })
    .catch((err: any) => {
      visit.error = this.Utils.getApiErrorMessage(err, 'Unable to do final pre-screen check');
      this.Utils.createErrorToast(err, 'Unable to do final pre-screen check');
    });
  }

  /**
   * Loops through selected visits in UI and attempts to process them
   */
  processSelectedVisits() {
    const selected = this.visits.filter((v: { selected: any; }) => v.selected);
    if (!selected.length) {
      return;
    }

    const loopThroughSelected = (s: any) => {
      if (!s || !s.length) {
        this.processing = false;
        return;
      }

      const visit = s.shift();
      this.processOneVisit(visit).then(() => loopThroughSelected(s));
    };

    this.processing = true;
    loopThroughSelected(selected);
  }

  /**
   * Loads prescreened visits and attaches the patient photo
   * {
     limit: 5,
     offset: 10,
     is_slv: '0',
     include_all_blocked: '0',
     has_default_med: true,
     admin_status: '0.1|5.1'
   }
   */
  search() {
    // @ts-ignore
    this.Orders.getBatchableVisits({ limit: 10, offset: 0 }).then(({ data }) => {
      const { data: visits, pagination } = data;
      visits.forEach((v: { id: any; photo: any; }) => {
        this.loadVisitPhotos(v);
      });

      Object.assign(this, { visits, pagination });
    });
  }

  loadVisitPhotos(visit: { id: any; photo: any; }) {
    // @ts-ignore
    return this.Orders.getPhotos(visit.id).then(({ data }) => {
      visit.photo = data.photos[0];
    });
  }
}

angular
  .module('pims')
  .component('batchVisits', {
    templateUrl: 'app/components/batch-visits.html',
    controller: BatchVisitController,
    controllerAs: '$ctrl',
    bindings: { lazyLoad: '<', shouldLoad: '<' },
  });
